import React from 'react';
import { useLang } from './LanguageContext';

// Bouton 🌐 de changement de langue — un simple <select> stylé, utilisable
// partout (sidebar, header public, pages auth). `compact` : n'affiche que le
// drapeau + code (sidebar) ; sinon drapeau + nom complet.
const LanguageSwitcher = ({ compact = false, className = '' }) => {
  const { lang, setLang, langs } = useLang();
  return (
    <select
      value={lang}
      onChange={(e) => setLang(e.target.value)}
      title="Langue / Language / اللغة"
      className={`cursor-pointer rounded-lg border border-gray-200 bg-white text-[#221C51] text-xs font-semibold px-2 py-1.5 focus:outline-none hover:border-gray-300 transition ${className}`}
    >
      {langs.map((l) => (
        <option key={l.code} value={l.code}>
          {l.flag} {compact ? l.code.toUpperCase() : l.label}
        </option>
      ))}
    </select>
  );
};

export default LanguageSwitcher;
